import React from "react";
import { Flex, Typography } from "antd";
import "./Details.scss"

const { Title, Text } = Typography;

const EscrowDetail = ({ vertical, gap, title, descLevel, copyable, desc }) => {
    return (
        <Flex vertical={vertical} gap={gap} className="escrow-details-container">
            <Text className="escrow-detail-title">
                {title}
            </Text>
            <Title level={descLevel} className="escrow-detail-desc" copyable={copyable}>
                {desc}
            </Title>
        </Flex>
    );
};

export default EscrowDetail;
